// @flow
import * as r from 'ramda';

export const tldToFormName = r.replace(/\./g, '_');

export const formNameToTld = r.replace(/_/g, '.');

export const getLegalMessages = (legal, domain) => {
  return r.pipe(
    r.when(
      r.always(r.is(Function, legal)),
      r.converge(
        r.append,
        [
          () => legal({
            isAd: domain.is_ad,
            tld: domain.extension,
            type: domain.type,
            isPromo: domain.promo,
          }),
          r.identity,
        ],
      ),
    ),
    r.append(domain.legalText),
    r.flatten,
    r.filter(Boolean),
  )([]);
};
